import React, { useCallback, useRef, useEffect } from 'react';
import classNames from 'classnames';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import { useNavigation } from '../../hooks';
var drawerClassName = 'react-navigation_drawer';

var Drawer = function Drawer(_ref) {
  var placement = _ref.placement,
      withOverlay = _ref.withOverlay,
      lockBodyScroll = _ref.lockBodyScroll,
      children = _ref.children,
      className = _ref.className,
      overlayClassName = _ref.overlayClassName;
  var drawerRef = useRef();

  var _useNavigation = useNavigation(),
      drawer = _useNavigation.drawer;

  var drawerClassNames = classNames(drawerClassName, "".concat(drawerClassName, "-").concat(placement), className);
  var overlayClassNames = classNames("".concat(drawerClassName, "-overlay"), overlayClassName);
  useEffect(function () {
    if (!lockBodyScroll) {
      return;
    }

    if (drawer.isOpen) {
      disableBodyScroll(drawerRef.current);
    } else {
      enableBodyScroll(drawerRef.current);
    }
  }, [drawer.isOpen, lockBodyScroll]);
  useEffect(function () {
    var drawer = drawerRef.current;
    return function () {
      enableBodyScroll(drawer);
    };
  }, []);
  var handleOverlayClick = useCallback(function () {
    drawer.close();
  }, [drawer]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, withOverlay && /*#__PURE__*/React.createElement("div", {
    className: overlayClassNames,
    "data-open": drawer.isOpen,
    "data-placement": placement,
    onClick: handleOverlayClick
  }), /*#__PURE__*/React.createElement("div", {
    ref: drawerRef,
    className: drawerClassNames,
    "data-open": drawer.isOpen,
    "data-placement": placement
  }, children));
};

Drawer.defaultProps = {
  placement: 'left',
  withOverlay: true,
  lockBodyScroll: true
};
export default Drawer;